import React, {useEffect, useState} from 'react';
import {Button, Form, Modal, ConfigProvider, notification, Select, Row, Col, Input, Switch} from 'antd';
import Axios from "../../../config/axiosConfig/axios";
import {Api} from "../../../config/apiList/api";
import {CopyOutlined} from "@ant-design/icons";
import unsecuredCopyToClipboard from "../../../config/copy_text_conf";

const UserDetail = ({ open, onCreate, onCancel, data}) => {
    const [form] = Form.useForm();

    useEffect(() => {
         console.log("data: ", data)
    }, [data])


    {/*useEffect(() => {*/}
    //     Axios.get(`${Api}get-user-detail-panel/${id}`
    //     )
    //         .then((data) => {
    //             if (data.statusCode === 200 || data.statusCode === 201) {
    //                 setData(data.data.data);
    //                 console.log("userDetail", data)
    //             }
    //
    //         })
    //         .catch((error) => {
    //             // console.log(`err is ${error}`);
    //         });
    // }, [open])

    return (
        <ConfigProvider direction="rtl">
            <Modal
                style={{fontFamily: "iranSansBold"}}
                bodyStyle={{height: 330}}
                // style={{fontFamily: "iranSansBold"}}

                width={400}
                open={open}
                title="جزئیات کاربر"
                okText="تایید"
                cancelText="انصراف"
                onCancel={onCancel}
                closable={false}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >

                <Row>
                    <Col span={24}>
                        <label>
                            اعتبار باقی مانده(روز)
                        </label>
                    </Col>
                </Row>


                <Row>
                    <Col span={24}>
                        <Input value={data.days} disabled={true} style={{textAlign: "center",
                        fontSize: "17px"}}/>
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <label>
                            اعتبار تا تاریخ
                        </label>
                    </Col>
                </Row>


                <Row>
                    <Col span={24}>
                        <Input value={data.validity !== null && data.validity !== null ? new Date(data.validity).toLocaleDateString("fa", { year: "numeric", day: '2-digit', month: '2-digit'}): "اعتبار ندارد"} disabled={true} style={{textAlign: "center",
                            fontSize: "17px"}}/>
                    </Col>
                </Row>

                <Row style={{marginTop: "20px"}}>
                    <Col span={10}>
                        <label>
                            کدفعالسازی
                        </label>
                    </Col>

                    <Col span={14}>
                        <Button type="primary" onClick={() => {
                            unsecuredCopyToClipboard(data.licence)
                            notification.open({
                                message: "موفقیت",
                                description: "کد کپی شد",
                                style: {
                                    background: "#43a047",
                                    color: "white",
                                    fontFamily: "IRANSansMobileFaNum",
                                    borderRadius: "5px",
                                }
                            })
                        }}>
                            <CopyOutlined/>
                        </Button>

                    </Col>
                </Row>

                <Row style={{marginTop: "10px"}}>
                    <Col span={24} >
                        <Input.TextArea disabled={true} value={
                             data.licence?data.licence:  ""
                        } style={{textAlign: "center", fontSize: "17px"}} />
                    </Col>
                </Row>

            </Modal>
        </ConfigProvider>
    );
};

const UserDetailModal = (props) => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState("");

    return (
        <div >
            <Button
                type="dashed"
                onClick={async () => {
                    await Axios.get(`${Api}get-user-detail-panel/${props.id}`
                    )
                        .then(async (data) => {

                            if (data.statusCode === 200 || data.statusCode === 201) {
                                await setData(data.data.data);
                                // console.log("userDetail", data)
                                setOpen(true);
                            }
                            else{
                                notification.open({
                                    message:  "اخطار",
                                    description: "جزئیات کاربر یافت نشد!",
                                    style: {
                                        background: "#F3585c",
                                        color: "white",
                                        fontFamily: "IRANSansMobileFaNum",
                                        borderRadius: "5px",
                                    }
                                })
                            }

                        })
                        .catch((error) => {
                            // console.log(`err is ${error}`);
                            // console.log("sadknsokadnoansd", error)


                        });


                }}
                style={{backgroundColor: "#e0e0e0"}}
            >
                جزئیات

            </Button>

            <UserDetail
                data={data}
                open={open}
                onCancel={() => {
                    setOpen(false);
                }}

            />
        </div>
    );
};
export default UserDetailModal;